import { motion } from "motion/react";
import type { ComponentProps, ReactNode } from "react";

type MotionDivProps = ComponentProps<typeof motion.div>;

interface HoverCardProps {
  parentClassName: string;
  className: string;
  initial: MotionDivProps["initial"];
  whileInView: MotionDivProps["whileInView"];
  viewport: MotionDivProps["viewport"];
  transition: MotionDivProps["transition"];
  children: ReactNode;
}

export const HoverCard = ({
  parentClassName,
  className,
  initial,
  whileInView,
  viewport,
  transition,
  children,
}: HoverCardProps) => {
  return (
    <div className={`hover-3d ${parentClassName}`}>
      <motion.div
        className={`${className}`}
        initial={initial}
        whileInView={whileInView}
        viewport={viewport}
        transition={transition}
      >
        {children}
      </motion.div>
      {Array.from({ length: 8 }, (_, i) => (
        <div key={i}></div>
      ))}
    </div>
  );
};
